<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <export-excel
          :fields = "listaExcelFields"
          :fetch = "gerarExcel"
          type = "xls"
          worksheet = "Ponto de Apoio"
          name = "zanzar-apuracao-mensal.xls"
          class="btn btn-sm btn-primary btn-novo" style="width: 33px"
          data-tooltip="Exportar Excel"
        ><i class="fa fa-file-excel"></i></export-excel>
        <button id="newButton" class="btn btn-sm btn-default btn-novo" @click="doFilter" style="width: 33px" data-tooltip="Atualizar"><i class="fa fa-refresh" aria-hidden="true"></i></button>
      </div>
    </div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"        
      @vuetable:loaded="onLoaded"
      no-data-template="Nenhum registro encontrado"
    >
      <template slot="competencia" slot-scope="props">
        {{ props.rowData.competencia_ano }}/{{ props.rowData.competencia_mes }}
      </template>
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-success': props.rowData.idc_status === 1,
            'label-warning': props.rowData.idc_status === 2,
            'label-info': props.rowData.idc_status === 3,
            'label-danger': props.rowData.idc_status === 4,
            'label-default': props.rowData.idc_status === 9
          }">{{ props.rowData.status_desc }}</span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-sm btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
            <a @click="abrirImagem(props.rowData.imgem_perfil)" class="btn btn-sm btn-info legitRipple" data-tooltip="Abrir Imagem" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="far fa-images"></span></a>
            <a @click="avaliarPerfil(props.rowData.cd_apuracao)" v-show="props.rowData.idc_status === 2" class="btn btn-sm btn-warning legitRipple" data-tooltip="Validar" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="fas fa-check-double"></span></a>
          </div>
        </div>
      </template>
    </vuetable>

    <div class="row vuetable-pagination ui basic segment grid" style="padding: 10px">
      <vuetable-pagination-info ref="paginationInfo"
        :css="css.pagination"
        info-template="Exibindo {from} - {to} de {total}"
        no-data-template="" />

      <vuetable-pagination ref="pagination"
        :css="css.pagination"
        @vuetable-pagination:change-page="onChangePage"
        style="margin: 0" />
    </div>

    <modal name="modal-imagem" :adaptive="false" width="600" height="90%" style="top: 20px">
      <div class="modal-content">
          <button type="button" class="close" @click="$modal.hide('modal-imagem')" style="padding-right: 10px; padding-top: 5px;"><span aria-hidden="true">×</span></button>
          <b-img v-bind:src="`${imagemPerfil}`" fluid-grow class="center-block" style="height: -webkit-fill-available; padding: 5px;"></b-img>
      </div>
    </modal>

    <modal name="modal-motorista" :adaptive="true" width="600" height="auto">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$modal.hide('modal-motorista')"><span aria-hidden="true">×</span></button>
          <h3 class="modal-title">{{ titleModal}}</h3>
        </div>
        <div class="modal-body" v-show="!isModalImagemPerfil">
					  <div v-show="errorMessageModal != ''" class="alert alert-danger">{{ errorMessageModal }}</div>

            <label for="historico">Observação <sup class="text-danger" v-show="!isModalPerfil">* </sup></label>
            <textarea id="historico" rows="4" v-model="historico" class="form-control" v-bind:class="{ 'box-input-required': errors.historico }"></textarea>
            <span v-show="errors.historico != null" class="help-inline">{{ errors.historico }}</span>
        </div>

        <div class="modal-body" v-show="isModalImagemPerfil">
          <img v-bind:src="`${imagemPerfil}`" />
        </div>

        <div class="modal-footer" v-show="!isModalImagemPerfil">
          <button type="button" class="btn btn-default pull-left" @click="$modal.hide('modal-motorista')">Cancelar</button>
          <button type="button" class="btn btn-primary" @click="modalConfirma()" v-show="!isModalPerfil">Confirmar</button>

          <button type="button" class="btn btn-danger" @click="avaliarPerfilReprovar()" v-show="isModalPerfil">Reprovar</button>
          <button type="button" class="btn btn-success" @click="avaliarPerfilAprovar()" v-show="isModalPerfil">Aprovar</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationInfo } from 'vuetable-2'
import VuetableCss from './../../helpers/VuetableCss'
import Formatters from '../../helpers/Formatters'

import ApuracaoMensalActions from '../../actions/ApuracaoMensalActions'
import ActionsLogin from '../../actions/LoginActions'
import moment from 'moment'

export default {
  name: 'Listar',
  props: ['titulo', 'status'],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo
  },
  data () {
    return {
      titleModal: '',
      isModalPerfil: false,
      isModalImagemPerfil: false,
      imagemPerfil: '',
      historico: null,
      cdApuracao: null,
      errorMessageModal: '',
      errors: {},
      listaExcelFields: {
        'Codigo': 'cd_apuracao',
        'Cod Motorista': 'cd_motorista',
        'Cod Ponto Apoio': 'cd_ponto_apoio',
        'Data': 'dt_agendada',
        'Observação': 'observacao',
        'Cod Status': 'idc_status',
        'Status': 'status_desc',
        'Criado em': 'createdAt',
        'Alterado em': 'updatedAt',
        'Motorista': 'motorista.nome',
        'CPF': 'motorista.cpf'
      },
      css: VuetableCss,
      filterText: '',
      urlApi: process.env.URL_API_BASE + '/apuracao-mensal' + ((this.status !== null && this.status !== undefined) ? ('/listar-por-status/' + this.status) : ''),
      fields: [
        {
          name: 'aplicativo.descricao',
          title: 'Aplicativo',
          sortField: 'aplicativo.descricao'
        },
        {
          name: '__slot:competencia',
          title: 'Competência',
          sortField: 'competencia_ano,competencia_mes'
        },
        {
          name: 'motorista.nome',
          title: 'Motorista',
          sortField: 'motorista.nome'
        },
        {
          name: 'motorista.tel_celular',
          title: 'Telefone',
          sortField: 'motorista.tel_celular',
          callback: 'formataNumeroTelefone'
        },
        {
          name: 'viagens_realizadas',
          title: 'Viagens Realizadas',
          sortField: 'viagens_realizadas'
        },
        {
          name: '__slot:status_desc',
          title: 'Status',
          sortField: 'status_desc'
        },
        {
          name: 'created_at',
          title: 'Criado em',
          sortField: 'created_at',
          callback: 'formataData'
        },
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'created_at', direction: 'desc' }
      ],
      moreParams: {}
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = this.titulo

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  watch: {
    status: function (val) {
      if (this.status !== null && this.status !== undefined) {
        this.$parent.$parent.$data.description = this.titulo
        this.urlApi = process.env.URL_API_BASE + '/apuracao-mensal/listar-por-status/' + this.status
      } else {
        this.$parent.$parent.$data.description = 'Listar'
        this.urlApi = process.env.URL_API_BASE + '/apuracao-mensal'
      }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
      this.$refs.paginationInfo.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    view (rowData) {
      this.$router.push({ path: '/apuracao-mensal/' + rowData.cd_apuracao, query: { ret_url: this.$router.currentRoute.path } })
    },
    async gerarExcel () {
      this.$refs.vuetable.refresh()
      let res = await ApuracaoMensalActions.listarPorStatus(this.status)
      return res
    },
    formataNumeroTelefone (val) {
      return val != null ? Formatters.formataNumeroTelefone(val) : ''
    },
    formataData (val) {
      let date = moment.utc(val)
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      }
      return ''
    },
    abrirImagem (imgemPerfil) {
      this.titleModal = 'Imagem Perfil'
      this.isModalPerfil = false
      this.isModalImagemPerfil = true
      this.errorMessageModal = ''
      this.errors = {}
      this.imagemPerfil = ApuracaoMensalActions.getUrlImagem(imgemPerfil)

      this.$modal.show('modal-imagem')
    },
    avaliarPerfil (cdApuracao) {
      this.titleModal = 'Avaliar'
      this.isModalPerfil = true
      this.isModalImagemPerfil = false
      this.historico = ''
      this.errorMessageModal = ''
      this.errors = {}
      this.cdApuracao = cdApuracao

      this.$modal.show('modal-motorista')
    },
    avaliarPerfilAprovar () {
      ApuracaoMensalActions.aprovar(this.cdApuracao, this.historico)
        .then(res => {
          this.$modal.hide('modal-motorista')
          this.$refs.vuetable.refresh()
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao gravar o registro.'
        })
    },
    avaliarPerfilReprovar (cdApuracao) {
      ApuracaoMensalActions.reprovar(this.cdApuracao, this.historico)
        .then(res => {
          this.$modal.hide('modal-motorista')
          this.$refs.vuetable.refresh()
        })
        .catch((error) => {
          console.log(error.message)
          this.errorMessageModal = 'Ocorreu um erro ao gravar o registro.'
        })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/apuracao-mensal/Listar.vue